module.exports = __webpack_public_path__ + "static/media/codeMario.e056f551.gif";